export default {
  app: {
    privacy: {
      policy: 'プライバシーポリシー',
      expansive: 'Expansiveを利用することで、Expansiveの{action}に同意したことになります',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'セッションの有効期限が切れました',
    sessionExpiredDescription:
      'セッションの有効期限が切れました。アプリケーションを引き続きご利用いただくには、再度ログインしてください。',
  },
  components: {
    appContainer: {
      chooseLanguage: '言語を選択',
      chooseLanguageDescription:
        'アプリケーションの表示言語を選択してください。インターフェースと言語が変更されます。',
    },
    userSelection: {
      cancel: 'キャンセル',
      createNewUser: '名前がリストにありません',
      newUser: '新しいユーザー',
      selectAnExistingUser: '既存のユーザーを選択',
      selectUserHint: '既存のユーザーを選択するか、新しいユーザーを作成して続行してください。',
      startTypingToSearch: '入力を開始してください...',
    },
    verification: {
      codeVerification: {
        continue: '続行',
        header: 'サイトアクセスコードを入力',
        invalidCode: '無効なコードです。再度お試しください。',
      },
      geoVerification: {
        continueWithoutVerifying: '位置情報を確認せずに続行',
        enterSiteAccessCode: 'サイトアクセスコードを入力',
        locationNotEnabledOrAvailable: 'なぜこれが表示されますか？',
        notAvailable: {
          description: 'GPS位置情報はこのデバイスでサポートされていません。',
          header: '位置情報がサポートされていません',
        },
        notEnabled: {
          description: '位置情報サービスが有効になっていないか、許可が付与されていません。',
          header: '位置情報が有効になっていません',
        },
        notVerified: {
          description: 'GPSによると現地にいません。',
          header: '位置情報が確認できません',
        },
        tryAgain: '再試行',
        unavailable: {
          description: 'GPS位置情報を確認できませんでした。',
          header: '位置情報が利用できません',
        },
        unknown: {
          description: '位置情報を特定できません。',
          header: '位置情報不明',
        },
        verified: {
          description: 'GPSによると現地にいます。',
          header: '位置情報が確認されました',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: '資産が見つかりません',
        emptyDescription: 'この作業指示に関連する資産はありません。',
        warrantyParts: '部品保証の有効期限',
        serialNumber: 'シリアル番号',
        none: 'なし',
      },
      updates: {
        emptyTitle: '更新が見つかりません',
        emptyDescription: 'この作業指示の更新はありません。',
        unknownUser: '不明なユーザー',
        none: 'なし',
        addComment: {
          buttonLabel: 'コメントを追加',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: '危険要因',
          no: 'いいえ',
          yes: 'はい',
        },
      },
    },
    attachmentsList: {
      attachments: '添付ファイル',
      documents: 'ドキュメント',
      siteDocuments: '現場ドキュメント',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: '危険要因',
        induction: '導入',
        safeToProceed: '作業を進めても安全',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: '期限日',
        activeSessions: 'アクティブなセッション',
        activeSessionsDescription:
          'すでに以下の作業指示にチェックインしています。新しい作業指示にチェックインする前に、これらの作業指示からチェックアウトする必要があります。',
        resumeSession: '再開',
        startTime: '開始時刻',
        unexpectedErrorTitle: '予期しないエラー',
        unexpectedErrorMessage:
          'セッションの作成中に予期しないエラーが発生しました。後でもう一度お試しください。',
        engineerNotFound: '技術者が見つかりません',
        engineerNotFoundDescription:
          'チェックインしようとしている技術者がシステムに見つかりません。管理者に連絡してください。',
      },
      verification: {
        code: {
          description:
            'チェックインするには、現場責任者または指定された連絡先から4桁のコードを取得してください。',
        },
        geo: {
          continue: '続行',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              '訪問を完了するには、現場責任者または指定の連絡先からアクセスコードを取得してください。',
            checkOut: 'チェックアウト',
            completeBeforeLeaving: '退出前に次のフォームを完了してください。',
            continue: '続行',
            noResolutionSelected: '続行する前に解決方法を選択してください。',
            quoteRequired: {
              hint: '訪問完了、見積もりを後日提出',
              label: '見積もりが必要',
            },
            returnVisitRequired: {
              hint: '再度訪問して作業を完了します',
              label: '再訪問が必要',
            },
            serviceCompleted: {
              hint: '追加対応不要',
              label: 'サービス完了',
            },
            uploadCheckout: 'ファイル、写真、またはビデオをアップロード',
            visitNotes: '訪問メモ',
            workOrderResolution: '作業指示の解決',
            enterNotes: 'ここにメモを入力してください...',
            errors: {
              timedOut: 'タイムアウト、30秒を超えました。もう一度お試しください。',
              closingSession: 'セッション終了時のエラー',
            },
          },
          success: {
            description:
              '{site}へのご訪問ありがとうございました。| {site}には残り1件の未完了作業指示があります。| {site}には残り{count}件の未完了作業指示があります。',
            endVisit: '訪問終了',
            header: '正常にチェックアウトしました',
            viewWorkOrders: '別の作業指示にチェックイン',
          },
          verification: {
            code: {
              description:
                'チェックアウトするには、現場責任者または指定された連絡先から4桁のコードを取得してください。',
              continue: '続行',
            },
            geo: {
              checkOut: 'チェックアウト',
              continue: '続行',
            },
          },
        },
        detail: {
          assets: '資産',
          call: '電話',
          checkOut: 'チェックアウト',
          closed: '完了',
          details: '詳細',
          dueBy: '期限日',
          manageEngineers: '技術者の管理',
          notAvailable: '利用不可',
          pointOfContact: '連絡先',
          siteAccessTimes: '現場アクセス時間',
          siteAccessInstructions: 'アクセス手順',
          siteAddress: '現場住所',
          siteNotes: '現場メモ',
          siteTelephone: '現場電話番号',
          siteLocation: '現場位置',
          updates: '更新',
          more: 'もっと見る',
          mismatchErrorTitle: '作業指示エラー',
          mismatchErrorMessage:
            'アクセスしようとしている作業指示は、現在チェックインしているものと一致しません。作業指示を確認して再度お試しください。',
          siteDocuments: '現場ドキュメント',
          validFrom: '有効開始日',
          validUntil: '有効終了日',
          documentName: 'ドキュメント名',
          documentType: 'ドキュメント種別',
          attachments: '作業指示ファイル',
          download: 'ダウンロード',
          workDetails: '作業詳細',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: '補助技術者を追加',
            assistantEngineers: '補助技術者',
            description: 'セキュリティ上、現場にいるすべての技術者の名前を指定してください。',
            editMainEngineer: '主担当技術者を編集',
            errors: {
              creatingEngineer: '技術者作成時のエラー',
              creatingSession: 'セッション作成時のエラー',
            },
            header: '現場の技術者',
            mainEngineer: '主担当技術者',
            newAssistantEngineer: 'フルネームを入力',
            next: '次へ',
            removeEngineer: '技術者を削除',
            selectExistingAssistantEngineer: '名前を入力して検索',
          },
          index: {
            description: 'セキュリティ上、現場にいるすべての技術者の名前を指定してください。',
            errorCreatingEngineer: '技術者作成時のエラー。再度お試しください。',
            header: '現場の技術者',
            hintMainEngineer: '主担当技術者のフルネームを入力',
            newMainEngineer: '新しい主担当技術者',
            next: '次へ',
            selectExistingMainEngineer: '既存の主担当技術者を選択',
            yes: 'はい',
            no: 'いいえ',
            mainEngineerLabel: 'あなたは主担当技術者ですか？',
          },
        },
        index: {
          callUsOn: '{phoneNumber} にお電話ください',
          description: 'お探しのものが見つかりませんか？',
          dueBy: '期限日',
          header: '作業指示を選択',
          notAvailable: '利用不可',
          searchWorkOrders: '作業指示を検索...',
        },
        manageEngineers: {
          manageEngineers: '技術者の管理',
          notWorking: '非稼働者',
          pause: '一時停止',
          resume: '再開',
          workingNow: '稼働中',
          startTime: '開始時刻',
          endTime: '終了時刻',
          duration: '所要時間',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'フィードバック',
            feedbackDescription:
              'サービス向上のため、作業指示に関するフィードバックをお願いします。',
            feedbackLabel: 'フィードバック',
            filesLabel: '添付ファイル',
            submissionLabel: 'フィードバックを送信',
          },
          hazards: {
            back: '戻る',
            hazards: '危険要因',
            next: '次へ',
            no: 'いいえ',
            noTasksForHazard: 'この危険要因に対する作業はありません。',
            yes: 'はい',
          },
          induction: {
            continue: '続行',
            induction: '導入',
          },
          index: {
            checkIn: 'チェックイン',
            description: '選択した作業のリスクアセスメントを完了してください。',
            fail: '作業開始チェックの処理に失敗しました。',
            haltMessage:
              '潜在的なリスクが検出されました。作業を中断し、安全ガイドラインを確認し、上司に連絡してください。',
            header: '作業開始チェック',
            endVisit: '訪問終了',
            leaveFeedback: 'フィードバックを残す',
          },
          safeToProceed: {
            continue: '続行',
            safeToProceed: '作業を進めても安全',
          },
        },
      },
    },
    index: {
      title: 'ようこそ',
      description: '現地のQRコードをスキャンして開始してください。',
    },
    login: {
      errorTitle: '予期しないエラー',
      errorMessage: '予期しないエラーが発生しました。もう一度QRコードをスキャンしてください。',
    },
    unauthenticated: {
      welcome: {
        title: '{site}へようこそ',
        description:
          '作業指示を表示する前に、あなたの情報を確認する必要があります。下のボタンをクリックして続行してください。',
        next: '続行',
      },
      index: {
        errorTitle: '予期しないエラー',
        errorMessage: '予期しないエラーが発生しました。もう一度QRコードをスキャンしてください。',
      },
      contractor: {
        title: 'どちらの会社に所属していますか？',
        contractor: '請負業者',
        contractorLabel: '会社名を入力してください',
        contractorHint: '3文字以上入力すると結果が表示されます',
        defaultSelectPlaceholder: '--選択してください--',
        next: '次へ',
      },
      user: {
        title: 'あなたは誰ですか？',
        cancel: 'キャンセル',
        createNewUserLabel: '名前がリストにありません',
        existingUserLabel: '名前を入力してください',
        existingUserHint: '3文字以上入力すると結果が表示されます',
        newUserLabel: 'フルネームを入力',
        next: '次へ',
        user: 'ユーザー',
      },
      verification: {
        methods: {
          add: {
            add: '認証方法を追加',
            defaultSelectPlaceholder: '--選択してください--',
            emailLabel: 'メール',
            existingMethodWarning:
              'この認証方法にはすでに管理者の承認待ちリクエストがあります。新しく追加すると上書きされます。',
            method: '方法',
            methodLabel: '方法',
            mobileCountryHint: '国番号を選択してください',
            mobileCountryLabel: '携帯国番号',
            mobileHint: '携帯番号を入力してください',
            mobileLabel: '携帯',
            title: '認証方法を追加',
          },
          confirm: {
            confirm: '確認',
            description: '続行するには認証方法を確認してください。',
            label: 'コードを入力',
            resend: '再送信',
            resendPrompt: 'コードが届きませんか？',
            title: '認証方法の確認',
          },
          confirmed: {
            description:
              'この認証方法が管理者に承認されると通知されます。その後、本人確認に使用できます。',
            forceApproval: '承認されるまで作業指示にアクセスできません。',
            nonForceApproval: '承認までの間、制限付きで作業指示にアクセスできます。',
            nonForceApprovalButtonLabel: '制限付きで続行',
            title: '承認待ち',
          },
          addNew: '新しい認証方法を追加',
          description: '作業指示にフルアクセスするには本人確認が必要です。',
          email: 'メール',
          hint: '選択した認証方法にリンクを送信します。既存の認証方法を変更する場合は管理者に連絡してください。',
          label: '認証方法を選択',
          next: '次へ',
          pendingHint: '管理者の承認待ち',
          sms: 'SMS',
          title: '認証',
        },
        optional: {
          hint: '本人確認を行うと作業指示にフルアクセスできます',
          label: '本人確認を行いますか？',
          next: '次へ',
          no: 'いいえ',
          noHint: '本人確認をせずに制限付きで作業指示を続行します',
          title: '認証',
          yes: 'はい',
          yesHint: '本人確認を行いフルアクセスを取得します',
        },
        sent: {
          description:
            '{identifier} にログインリンクを送信しました。リンクをクリックしてログインを完了してください。',
          title: 'ログインリンク送信済み',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: '昨日',
      today: '今日',
      days: {
        monday: '月曜日',
        tuesday: '火曜日',
        wednesday: '水曜日',
        thursday: '木曜日',
        friday: '金曜日',
        saturday: '土曜日',
        sunday: '日曜日',
      },
      months: {
        january: '1月',
        february: '2月',
        march: '3月',
        april: '4月',
        may: '5月',
        june: '6月',
        july: '7月',
        august: '8月',
        september: '9月',
        october: '10月',
        november: '11月',
        december: '12月',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: '問題が発生しました',
      message: 'もう一度QRコードをスキャンしてください。',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: '不明なユーザー',
      },
      none: 'なし',
      types: {
        stateTransition: 'ステータス変更',
        contractorAssigned: '請負業者割り当て',
        engineerAssigned: '技術者割り当て',
        serviceAssigned: 'サービス割り当て',
        priorityChanged: '優先度変更',
        actionableDateChanged: '対応日変更',
        dueDateChanged: '期限日変更',
        etaDateChanged: '到着予定日変更',
        spendLimitApproved: '支出限度額承認',
        spendLimitCancelled: '支出限度額リクエスト取消',
        spendLimitRejected: '支出限度額却下',
        spendLimitRequested: '支出限度額リクエスト',
        jobSheetUploaded: '作業報告書アップロード',
        slaAlertSent: '対応時間SLA違反アラート',
        issuedWorkPermit: '作業許可証発行',
        requestForServiceSent: 'サービス依頼送信',
        comment: 'コメント追加',
        unknown: '不明なイベント',
      },
      labels: {
        actionableDate: '対応日',
        comment: 'コメント',
        file: 'ファイル',
        contractor: '請負業者',
        dueDate: '期限日',
        etaDate: '到着予定日',
        engineer: '技術者',
        priority: '優先度',
        requestForService: 'サービス依頼',
        service: 'サービス',
        spendLimit: '支出限度額',
        status: 'ステータス',
        workPermit: '作業許可証',
      },
    },
  },
}
